<div class="calendar-reminder-toast" data-copilot="calendar-reminder">
    <i class="fa-regular fa-calendar calendar-reminder-toast-icon" aria-hidden="true"></i>
    <div class="calendar-reminder-toast-message">
        <span class="calendar-reminder-toast-title" [attr.title]="data.title">{{ data.title }}</span>
        <span class="calendar-reminder-toast-when">{{ data.when }}</span>
    </div>
    <button type="button" class="calendar-reminder-toast-join" *ngIf="data.canJoin" (click)="join()"
            [attr.aria-label]="'Join ' + data.title" data-copilot="calendar-reminder-join">
        <i class="fa-solid fa-video" aria-hidden="true"></i>
        <span>Join</span>
    </button>
    <button type="button" class="calendar-reminder-toast-dismiss" (click)="dismiss()" data-copilot="calendar-reminder-dismiss">
        Dismiss
    </button>
</div>
